import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextEditor.css";  // Adjust path based on your directory structure


const RichTextEditor = ({values,setFieldValue}) => {
 
     const handleChange = (content)=>{
        setFieldValue('productOverview.description[0]',content)
     }
    const modules = {
        toolbar: [


            // Font family and size
            [{ font: [] }],
            [{ size: [] }],

            // Headers
            [{ header: [1, 2, 3, false] }],
            
            // Bold, italic, underline, strikethrough
            ["bold", "italic", "underline", "strike"],
            
            // Font color and background color
            [{ color: [] }, { background: [] }],

            // Subscript and superscript
            [{ script: "sub" }, { script: "super" }],

            // Blockquote
            ["blockquote"],

            // Lists
            [{ list: "ordered" }, { list: "bullet" }],

            // Text alignment
            [{ align: [] }],

            // Links and media
            ["link", "image"],

            // Code block
            ["code-block"],

        ],
    };

    const formats = [
        "size",
        "font",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "blockquote",
        "list",
        "bullet",
        "align",
        "link",
        "image",
        "code-block",
        "header", "height",

        "color", "bullet", "indent",
        "align", "size", "formula", "width", "style"
    ];

    return (
        <div>
               <ReactQuill
                theme="snow"
                onChange={(e)=>handleChange(e)}
                value={values.productOverview?.description[0]}
                // readOnly
                modules={modules}
                formats={formats}
                placeholder="Type description here..."
                style={{ borderRadius: "0px" }}
            />

        </div>
    );
};

export default RichTextEditor;
